import React from "react";

export const RateHistoryTooltip = ({ x, y, visible, maxValue, minValue, medianValue }) => {
    const hasData = maxValue != null && minValue != null && medianValue != null;
    const isValidPosition = isFinite(x) && isFinite(y);

    if (!visible || !isValidPosition) return null;

    return (
        <div
            className="absolute bg-cm-p-surface shadow-lg rounded-[5px] py-2 px-3 pointer-events-none z-10 border border-cm-p-outline"
            style={{
                left: x,
                top: y,
                transform: "translateY(-50%)",
                minWidth: 180,
                height: 100,
            }}
        >
            {hasData ? (
                <div className="flex flex-col gap-2 text-cm-p-text-primary">
                    <div className="flex justify-between gap-4 leading-[19px] text-xs">
                        <span>Min</span>
                        <span>{minValue}</span>
                    </div>
                    <div className="flex justify-between gap-4 leading-[19px] text-xs">
                        <span>Max</span>
                        <span>{maxValue}</span>
                    </div>
                    <div className="w-full h-[1px] bg-cm-p-outline" />
                    <div className="flex justify-between gap-4 leading-[22px] text-sm font-medium">
                        <span>Median rate</span>
                        <span>{medianValue}</span>
                    </div>
                </div>
            ) : (
                <div className="text-xs">
                    <span className="text-cm-p-text-primary italic">No info for this month</span>
                </div>
            )}
        </div>
    );
};
